import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faChartBar, faDatabase, faBoxOpen, faMobileAlt, faCommentDots, faShieldAlt, faCloud, faTrophy, faHeart } from '@fortawesome/free-solid-svg-icons';
import "./Footer.css";

const Footer = () => {

  return (
    <footer className="site-footer">
      {/* ── MAIN FOOTER ── */}
      <div className="ft-main">
        <div className="ft-main-inner">

          {/* Column 1: Brand */}
          <div className="ft-col ft-col-brand">
            <Link to="/" className="ft-logo-link">
              <img src="/images/auditlogo.png" alt="Auditus-iERP" className="ft-logo" />
            </Link>
            <p className="ft-brand-desc">
              Auditus-iERP business management software connects billing, inventory, accounting, GST, POS, sales, purchases, customers, suppliers, payments, and reports.
            </p>
            <div className="ft-trust-badges">
              <div className="ft-badge">
                <span className="ft-badge-icon"><FontAwesomeIcon icon={faShieldAlt} /></span>
                <span>GST Certified</span>
              </div>
              <div className="ft-badge">
                <span className="ft-badge-icon"><FontAwesomeIcon icon={faCloud} /></span>
                <span>Cloud Secured</span>
              </div>
              <div className="ft-badge">
                <span className="ft-badge-icon"><FontAwesomeIcon icon={faTrophy} /></span>
                <span>5000+ Users</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="ft-socials">
              <a href="https://facebook.com/auditusierp" target="_blank" rel="noreferrer" className="ft-social-icon" aria-label="Facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
              </a>
              <a href="https://instagram.com/auditusierp" target="_blank" rel="noreferrer" className="ft-social-icon" aria-label="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" /></svg>
              </a>
              <a href="https://youtube.com/@auditusierp" target="_blank" rel="noreferrer" className="ft-social-icon" aria-label="YouTube">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
              </a>
              <a href="https://twitter.com/auditusierp" target="_blank" rel="noreferrer" className="ft-social-icon" aria-label="X / Twitter">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
              </a>
              <a href="https://wa.me/919032032612" target="_blank" rel="noreferrer" className="ft-social-icon ft-social-whatsapp" aria-label="WhatsApp">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" /></svg>
              </a>
            </div>
          </div>

          {/* Column 2: Products */}
          <div className="ft-col">
            <h4 className="ft-col-title">Products</h4>
            <ul className="ft-links">
              <li><Link to="/Productoverview">Product Overview</Link></li>
              <li><Link to="/whatsnew">What's New</Link></li>
              <li><Link to="/Features">All Features</Link></li>
              <li><Link to="/Pricing">Pricing Plans</Link></li>
              <li><Link to="/Industrial-specification">Industry Solutions</Link></li>
              <li><Link to="/Demo">Request Demo</Link></li>
            </ul>
          </div>

          {/* Column 3: Solutions */}
          <div className="ft-col">
            <h4 className="ft-col-title">Solutions</h4>
            <ul className="ft-links">
              <li><Link to="/Industrial-specification">Supermarkets & Retail</Link></li>
              <li><Link to="/Industrial-specification">Pharmacy & Medical</Link></li>
              <li><Link to="/Industrial-specification">Garments & Fashion</Link></li>
              <li><Link to="/Industrial-specification">Distribution & FMCG</Link></li>
              <li><Link to="/Industrial-specification">Hardware & Electricals</Link></li>
              <li><Link to="/Industrial-specification">Manufacturing</Link></li>
            </ul>
          </div>

          {/* Column 4: Resources & Support */}
          <div className="ft-col">
            <h4 className="ft-col-title">Resources</h4>
            <ul className="ft-links">
              <li><Link to="/Support">Help Center</Link></li>
              <li><Link to="/creation/productcreation">Product Creation Guide</Link></li>
              <li><Link to="/creation/accountcreation">Account Setup Guide</Link></li>
              <li><Link to="/creation/salesbills">Sales Entry Guide</Link></li>
              <li><Link to="/creation/purchasebills">Purchase Entry Guide</Link></li>
              <li><Link to="/Brochure">Brochure</Link></li>
            </ul>
          </div>

          {/* Column 5: Downloads */}
          <div className="ft-col">
            <h4 className="ft-col-title">Downloads</h4>
            <ul className="ft-links">
              <li>
                <a href="/Download/Downloads/Auditusierp18.5.5.9.rar">
                  <span className="ft-dl-icon"><FontAwesomeIcon icon={faDesktop} /></span> Auditus-iERP v18.5
                </a>
              </li>
              <li>
                <a href="/Download/Downloads/AuditusierpReportTool 18.5.5.9.rar">
                  <span className="ft-dl-icon"><FontAwesomeIcon icon={faChartBar} /></span> Report Tool
                </a>
              </li>
              <li>
                <a href="/Download/Downloads/mysql 8.0.31.rar">
                  <span className="ft-dl-icon"><FontAwesomeIcon icon={faDatabase} /></span> MySQL 8.0.31
                </a>
              </li>
            </ul>
            <h4 className="ft-col-title ft-col-title--mt">Mobile Apps</h4>
            <ul className="ft-links">
              <li>
                <a href="/Download/Mobile_app/AuditRack.apk" target="_blank" rel="noopener noreferrer">
                  <span className="ft-dl-icon"><FontAwesomeIcon icon={faBoxOpen} /></span> AuditRack (Android)
                </a>
              </li>
              <li>
                <a href="/Download/Mobile_app/AuditusIerp-Mobileapp.apk" target="_blank" rel="noopener noreferrer">
                  <span className="ft-dl-icon"><FontAwesomeIcon icon={faMobileAlt} /></span> Auditus-iERP App
                </a>
              </li>
            </ul>
          </div>

          {/* Column 6: Contact Us */}
          <div className="ft-col ft-col-contact">
            <h4 className="ft-col-title">Contact Us</h4>
            <div className="ft-contact-items">
              <a href="tel:+919032032612" className="ft-contact-item">
                <span className="ft-contact-icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg></span>
                <span>+91 9032032612</span>
              </a>
              <a href="mailto:auditusierp@gmail.com" className="ft-contact-item">
                <span className="ft-contact-icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg></span>
                <span>auditusierp@gmail.com</span>
              </a>
              <div className="ft-contact-item">
                <span className="ft-contact-icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg></span>
                <span>Hyderabad, Telangana, India</span>
              </div>
              <div className="ft-contact-item">
                <span className="ft-contact-icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg></span>
                <span>Mon – Sat, 9 AM – 7 PM IST</span>
              </div>
            </div>
            <div className="ft-contact-cta">
              <Link to="/Demo" className="ft-contact-demo-btn">Get a Free Demo →</Link>
              <a href="https://wa.me/919032032612" target="_blank" rel="noreferrer" className="ft-contact-wa-btn"><FontAwesomeIcon icon={faCommentDots} /> Chat on WhatsApp</a>
            </div>
          </div>
        </div>
      </div>

      {/* ── STATS STRIP ── */}
      <div className="ft-stats-strip">
        <div className="ft-stats-inner">
          <div className="ft-stat">
            <span className="ft-stat-num">5000+</span>
            <span className="ft-stat-label">Active Businesses</span>
          </div>
          <div className="ft-stat-divider" />
          <div className="ft-stat">
            <span className="ft-stat-num">100+</span>
            <span className="ft-stat-label">Industries Served</span>
          </div>
          <div className="ft-stat-divider" />
          <div className="ft-stat">
            <span className="ft-stat-num">99.9%</span>
            <span className="ft-stat-label">Uptime Guarantee</span>
          </div>
          <div className="ft-stat-divider" />
          <div className="ft-stat">
            <span className="ft-stat-num">24/7</span>
            <span className="ft-stat-label">Expert Support</span>
          </div>
        </div>
      </div>

      {/* ── BOTTOM BAR ── */}
      <div className="ft-bottom">
        <div className="ft-bottom-inner">
          <p className="ft-copyright">
            © {new Date().getFullYear()} <strong>Auditus IERP</strong> All Rights Reserved.
          </p>
          <div className="ft-bottom-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <span className="ft-dot">•</span>
            <a href="/terms-and-conditions">Terms &amp; Conditions</a>
            <span className="ft-dot">•</span>
            <span>Refund Policy</span>
          </div>
          <p className="ft-made-with">
            Made with <span className="ft-heart"><FontAwesomeIcon icon={faHeart} /></span> in India
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


